
// @ts-nocheck
/* eslint-disable */
import { defineComponent } from 'vue'
import BaseForm from './base-form'
import toolbar from '@/mixins/toolbar'
import { Action } from '@/common/constant'
import type { Action as MessageBoxAction } from '@/components/message-box'

export default defineComponent({
  name: 'BaseDetail',

  extends: BaseForm,

  mixins: [toolbar],

  data () {
    return {
      isCheckChange: true, // Kiểm tra thay đổi dữ liệu
      currentItem: {} // Item detail hiện tại
    }
  },

  created () {
    this.primitiveSource = Object.freeze({ ...this.currentItem })
  },

  mounted () {
    this.initToolbar()
  },

  methods: {
    /**
     * @override
     * @author PHNam
     */
    async loadFormData () {

      const me = this
      const container = me.getContainer()
      const editMode = me.$enumeration.EditMode

      switch (me.editMode) {
        // Thêm mới -> load và binding dữ liệu mặc định
        case editMode.Add:
          me.load(me.getInitDetailData())
          break

        case editMode.Edit:
        case editMode.View:
          me.$commonFn.showMask(container)

          await me.loadDataByService()
            .then((data) => {

              data && me.load(data)
            })
            .catch((err) => {
              me.$commonFn.handleNetworkError(err)
            })
            .finally(() => {
              me.$commonFn.hideMask(container)
            })
      }

      return true
    },

    /**
     * @description Khởi tạo editMode cho form
     * @author PHNam
     */
    initParams () {
      const me = this

      if (me?.config?.editMode) {
        me.editMode = me.config.editMode
      }
    },

    /**
     * @description Lấy dữ liệu từ server
     * @author PHNam
     */
    async loadDataByService () {
      const me = this
      const config = me.moduleConfig

      if (config) {
        const key = me?.formParams[config.entityKey]

        return new Promise((resolve, reject) => {
          this.$store
            .dispatch(
              `${config.moduleName}/${Action.GET}${config.entityName}`,
              key
            )
            .then((result) => {
              if (result === true) {
                const data =
                  me.$store.getters[
                    `${config.moduleName}/${Action.GET}${config.entityName}`
                  ]

                resolve(data)
              }
            })
            .catch((err) => {
              return reject(err)
            })
        })
      }
    },

    /**
     * @description Load + focus control
     * @author PHNam
     */
    async load (data) {
      const me = this
      // me.$commonFn.showMask(me.getContainer())
      await me.loadControlData()

      me.resetControlAndBinding(data)
      // me.$commonFn.hideMask(me.getContainer())
    },

    /**
     * @description Setup form và binding dữ liệu
     * @author PHNam
     */
    resetControlAndBinding (data) {
      const me = this
      me.resetControls()
      // Thực hiện binding dữ liệu
      me.bindingData(data)

      // Update UI theo trạng thái
      // me.setViewMode(me.editMode)
      // Focus control nhập liệu
      me.focusFirstControl()
    },

    /**
     * @description Reset các control
     * @author PHNam
     */
    resetControls () {
      const me = this
      const validateInstance = me.getValidateInstance()

      validateInstance && validateInstance.reset()
    },

    /**
     * @description Load dữ liệu cho các control cần lấy dữ liệu từ server
     * @author PHNam
     */
    async loadControlData () {},

    /**
     * @description Binding + set origrin
     * @author PHNam
     */
    bindingData (data) {
      const me = this
      const customSource = me.getCustomSource()
      const sourceData = Object.assign(data || {}, customSource)

      me.bindDataToControls(sourceData)
    },

    /**
     * @description Gán lại dữ liệu vào props hoặc data để binding vào control
     * @author PHNam
     */
    bindDataToControls (data) {
      const me = this

      me.currentItem = { ...this.primitiveSource, ...data }
      me.bindCustom(data)
      me.updateOriginalSourceData()
    },

    /**
     * @description Thực hiện bind custom
     * @author PHNam
     */
    bindCustom (data) {
      // console.log(data)
    },

    /**
     * @description Update dữ liệu ban đầu, phục vụ kiểm tra thay đổi dữ liệu
     * @author PHNam
     */
    updateOriginalSourceData () {
      const me = this

      me.originSource = Object.freeze({ ...me.currentItem })
    },

    /**
     * @description Trả về source custom (nếu có)
     * @author PHNam
     */
    getCustomSource () {
      return {}
    },

    /**
     * @description focus vào ô control nhập liệu đầu tiên
     * @author PHNam
     */
    focusFirstControl () {
      const container = this.getContainer()

      container && this.$commonFn.focusFirstControl(container)
    },

    /**
     * @description Load dữ liệu
     * @author PHNam
     */
    async loadData () {},

    /**
     * @abstract
     * @description Trả về dữ liệu khi tạo mới
     * @author PHNam
     */
    getInitDetailData () {
      return {}
    },

    /**
     * @description Xử lý toolbar button
     * @author PHNam
     */
    onToolbarItemClick (command, button) {
      const me = this
      const commandName = me.$enumeration.CommandName
      const isAdd = command === commandName.SaveAdd

      switch (command) {
        case commandName.SaveAdd:
        case commandName.Save:
          me.onSave(isAdd)
          break
        default:
          me.onToolbarItemCustomClick(command, button)
      }
    },

    /**
     * @description Xử lý khi các command nằm ngoài
     * @author PHNam
     */
    onToolbarItemCustomClick (command, button) {
      // console.log(command, button)
    },

    /**
     * @description Xử lý khi lưu và thêm
     * @author PHNam
     */
    onSaveAdd () {
      const me = this

      me.onSave(true)
    },

    /**
     * @description Xử lý khi lưu
     * @param isInitAddNew chuyển sang mode add luôn
     * @author PHNam
     */
    async onSave (isInitAddNew = false) {
      const me = this

      me.showMask()
      const isValid = await me.validate()

      if (isValid) {
        me.doSave()
          .then(isSuccess => {
            if (isSuccess) {
              me.doAfterSave(isSuccess, isInitAddNew)
            }
          })
          .catch(err => {
            // console.log(err)
            me.notifySave(false)
          })
          .finally(() => {me.hideMask()})
      } else {
        me.hideMask()
      }
    },

    /**
     * @description Validate trước khi lưu
     * @author PHNam
     */
    async validate () {
      return this.validateComponents() && (await this.validateBusiness())
    },

    /**
     * @description Validate các component
     * @author PHNam
     */
    validateComponents () {
      const me = this
      const validateIntance = me.getValidateInstance()
      let isValid = false
      let isValidCustom = true

      if (validateIntance) {
        isValid = validateIntance.isValid()
      }
      isValidCustom = me.validateComponentsCustom()

      return isValid && isValidCustom
    },

    /**
     * @description validate control theo từng màn
     * @author PVThang
     */
    validateComponentsCustom () {
      return true
    },

    /**
     * @description Lấy ra instance validate
     * @author PHNam
     */
    getValidateInstance () {
      const me = this
      const validateIntance = me.$commonFn.getValidateInstance(me.getContainer())

      return validateIntance
    },

    /**
     * @description Validate nghiệp vụ trước khi lưu
     * @author PHNam
     */
    async validateBusiness () {
      return true
    },

    /**
     * @description Thực hiện lưu
     * @author PHNam
     */
    async doSave () {
      const me = this
      const editMode = me.$enumeration.EditMode
      let action = me.defaultHandler

      switch (me.editMode) {
        case editMode.Add:
          action = me.add
          break
        case editMode.Edit:
          action = me.update
          break
        case editMode.Duplicate:
          action = me.dublicate
          break
      }

      return action()
    },

    /**
     * @description Thêm mới
     * @author PHNam
     */
    add () {
      const me = this
      const config = me.moduleConfig

      if (config) {
        // return new Promise((resolve, reject) => {
        const entity = { ...me.currentItem }

        if (config.entityKey) {
          delete entity[config.entityKey]
        }

        return me.$store
          .dispatch(
              `${config.moduleName}/${Action.ADD}${config.entityName}`,
              entity
          )

        // })
      }
    },

    /**
     * @description Cập nhật
     * @author PHNam
     */
    update () {
      const me = this
      const config = me.moduleConfig

      if (config) {
        return new Promise((resolve, reject) => {
          me.$store
            .dispatch(
              `${config.moduleName}/${Action.UPDATE}${config.entityName}`,
              me.currentItem
            )
            .then((result) => resolve(result))
            .catch((err) => {
              reject(err)
              me.$commonFn.handleNetworkError(err)
            })
        })
      }

      return me.defaultHandler()
    },

    /**
     * @description nhân bản
     * @author NTQuy
     */
    dublicate() {

    },

    /**
     * @description Xử lý sau khi lưu thành công
     * @param isSuccess Thành công
     * @param isInitAddNew Thêm mới hay không
     * @author PHNam
     */
    doAfterSave (isSuccess, isInitAddNew) {
      const me = this

      me.notifySave(isSuccess)
      if (isInitAddNew === true) {
        me.prepareForAddNew()
      } else {
        me.doAfterNotify(isSuccess)
      }
    },

    /**
     * @description Thông báo lưu thành công
     * @param isSuccess Thành công
     * @author PHNam
     */
    notifySave (isSuccess) {
      const me = this

      const notify = isSuccess ? me.$notify.showSuccess : me.$notify.showError
      const message = isSuccess
        ? me.$t('NotifyMessage.SavedSuccess')
        : me.$t('NotifyMessage.ErrorOccurred')

      notify({
        title: me.$t('NotifyMessage.Title'),
        message
      })
    },

    /**
     * @description Làm gì đó sau khi thông báo
     * @param isSuccess Thành công
     * @author PHNam
     */
    doAfterNotify (isSuccess) {
      // console.log(isSuccess)
    },

    /**
     * @description Chuẩn bị cho add thêm bản ghi mới
     * @author PHNam
     */
    prepareForAddNew () {
      const me = this

      me.editMode = me.$enumeration.EditMode.Add
      me.setupControlAndBinding(me.getInitDetailData())
    },

    /**
     * @description Kiểm tra thay đổi
     * @author PHNam
     */
    checkChange () {
      const me = this
      const ignoreCheckChange = me.getIgnoreCheckChange()

      return me.$commonFn.checkChange(
        me.originSource,
        me.currentItem,
        ignoreCheckChange
      )
    },

    /**
     * @description Trả vê các thuộc tính bỏ qua khi check change
     * @author PHNam
     */
    getIgnoreCheckChange () {
      return null
    },

    /**
     * @description Cảnh báo thay đổi và không lưu
     * @author PHNam
     */
    warningChange (hide) {
      const me = this

      me.$message.show({
        message: me.$t('NotifyMessage.ConfirmChanged'),
        confirmButtonText: me.$t('Button.Save'),
        cancelButtonText: me.$t('Button.Back'),
        ignoreButtonText: me.$t('Button.DoNotSave'),
        showCancelButton: true,
        showIgnoreButton: true,
        callback: me.warningChangeCallback.bind(me, hide)
      })
    },

    /**
     * @description Xử lý sau khi đã hỏi dữ liệu thay đổi và người dùng có muốn lưu hay không
     * @param {Function} hide Hàm đóng popup
     * @param {String} action Hành động người dùng chọn
     * @author PHNam
     */
    warningChangeCallback (hide: Function, action: MessageBoxAction) {
      switch (action) {
        case 'confirm':
          this.onSave()
          break
        case 'ignore':
          hide()
          break
        default:
          break
      }
    }
  }
})
